import { render } from "./MeasureResultBodyWithOf.vue?vue&type=template&id=519b0782&scoped=true"
import script from "./MeasureResultBodyWithOf.vue?vue&type=script&lang=js"
export * from "./MeasureResultBodyWithOf.vue?vue&type=script&lang=js"

import "./MeasureResultBodyWithOf.vue?vue&type=style&index=0&id=519b0782&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519b0782"]])

export default __exports__